define('ShopByModel.Collection',
  [
    'SCCollection',
    'ShopByModel.Model',
    'Utils'
  ], function (
    SCCollectionModule,
    GoferModelModel,
    Utils
  ) {
    'use strict';

    var SCCollection = SCCollectionModule.SCCollection;

    function GoferModelCollection(models, options) {
      SCCollection.call(this, models, options);

      this.model = GoferModelModel;
      this.url = function () {
        return Utils.getAbsoluteUrl(getExtensionAssetsPath('services/ShopByModel.Service.ss'));
      };
    }

    GoferModelCollection.prototype = Object.create(SCCollection.prototype);
    GoferModelCollection.prototype.constructor = GoferModelCollection;

    GoferModelCollection.prototype.parse = function (response) {
      this.totalRecordsFound = response.totalRecordsFound;
      this.recordsPerPage = response.recordsPerPage;
      this.page = response.page;
      return response.records;
    };

    GoferModelCollection.prototype.update = function (options) {
      this.fetch({
        data: {
          page: options.page,
          goferCompany: options.goferCompany
        },
        reset: true,
        killerId: options.killerId
      });
    };

    return GoferModelCollection;
  });
